import React, { useState, useEffect } from "react";

import { Box, TextField, Typography } from "@mui/material";
import { useMrtSurfaceProps } from "../../../../../../../styles/mrtThemeProps";

import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { lightTable } from "../../../../../../../styles/muiProps";

import { useStructureModeling } from "../../structureModelingContext";

export default function TotalSummaryTable() {
  const { totalSummary, setTotalSummary } = useStructureModeling();
  const mrtSurfaceProps = useMrtSurfaceProps();

  const table = useMaterialReactTable({
    ...mrtSurfaceProps,
    data: totalSummary,

    columns: [
      {
        accessorKey: "name",

        header: "",

        enableColumnActions: false,

        size: 150,
      },

      {
        accessorKey: "value",

        header: "Qty",

        enableColumnActions: false,

        size: 80,

        muiTableHeadCellProps: {
          align: "center",
        },

        muiTableBodyCellProps: {
          align: "center",
        },

        Cell: ({ row, cell }) => {
          if (row.original.name === "Total Materials Cost") return ""; // ← never show in Qty column
          return row.original.name === "Miscellaneous" ? (
            <TextField
              type="number"
              size="small"
              placeholder="Miscellaneous"
              variant="standard"
              value={row.original.value || ""}
              sx={{
                "& input": {
                  textAlign: "center",
                },
              }}
              onChange={(e) => {
                const state = totalSummary.map((r) => {
                  return r.name === "Miscellaneous"
                    ? {
                        ...r,

                        value: e.target.value,

                        total: Number(r.rate) * Number(e.target.value),
                      }
                    : r;
                });

                setTotalSummary(state);
              }}
              fullWidth
            />
          ) : Number(row.original.value) ? (
            row.original.value
          ) : (
            ""
          );
        },
      },

      {
        accessorKey: "unit",

        header: "Unit",

        enableColumnActions: false,

        size: 50,

        muiTableHeadCellProps: {
          align: "center",
        },

        muiTableBodyCellProps: {
          align: "center",
        },
      },

      {
        accessorKey: "rate",

        header: "Rate ($)/ Unit",

        enableColumnActions: false,

        size: 100,

        muiTableHeadCellProps: {
          align: "center",
        },

        Cell: ({ row, cell }) => {
          const { name } = row.original;

          if (row.original.name === "Total Materials Cost") {
            return <Box sx={{ textAlign: "center", fontSize: 20 }}>-</Box>;
          }

          if (row.original.name === "Miscellaneous") {
            return <Box sx={{ textAlign: "center", fontSize: 20 }}>1</Box>;
          }

          return (
            <TextField
              type="number"
              size="small"
              placeholder="Enter Rate"
              variant="standard"
              value={row.original.rate || ""}
              sx={{
                "& input": {
                  textAlign: "center",
                },
              }}
              onChange={(e) => {
                const state = totalSummary.map((r) => {
                  return r.name === name
                    ? {
                        ...r,

                        rate: e.target.value,

                        total: (Number(r.value) * Number(e.target.value))

                          .toFixed(2)

                          .toString(),
                      }
                    : r;
                });

                setTotalSummary(state);
              }}
              fullWidth
            />
          );
        },
      },

      {
        accessorKey: "total",

        header: "Total $",

        enableColumnActions: false,

        size: 100,

        muiTableHeadCellProps: {
          align: "center",
        },

        muiTableBodyCellProps: {
          align: "center",
        },

        Cell: ({ row }) => {
          if (row.original.name === "Total Materials Cost") {
            return Number(row.original.value) ? row.original.value : "";
          }
          return Number(row.original.total) ? row.original.total : "";
        },
      },
    ],

    ...lightTable,
  });

  return (
    <Box sx={{ p: 2, width: "750px", ml: 14.3 }}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Total Cost Summary:
      </Typography>
      <MaterialReactTable table={table} />

      <Box sx={{ textAlign: "right" }}>
        <Box
          sx={{
            mt: 2,

            p: 1,

            border: "1px solid",
            borderColor: "divider",
            width: "45%",
            textAlign: "left",
            display: "inline-block",
            fontWeight: "bold",
            borderRadius: 1,
            color: "text.primary",
          }}
        >
          <span style={{ marginRight: "60px" }}>Total Project Cost =</span>

          {totalSummary
            ?.reduce((acc, curr) => {
              if (curr.name === "Total Materials Cost")
                return acc + Number(curr.value || 0); // ← reads value for this row
              return acc + Number(curr.total || 0);
            }, 0)
            ?.toFixed(2)}
        </Box>
      </Box>
    </Box>
  );
}
